import styled from "styled-components";

import FlexBox from "../FlexBox";
import { ACCENT_800, DAVYS_GREY_200, DAVYS_GREY_400 } from "../colors";

export const Header = styled(FlexBox)`
  padding: 1rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  background-image: url(${({ bgImage }) => bgImage});
  background-size: ${({ bgSize }) => bgSize || "auto 108px"};
  background-position: center;
  background-repeat: no-repeat;
  min-height: ${({ headerHeight }) => headerHeight || "13.75rem"};
  position: relative;
`;

export const Content = styled(FlexBox)`
  padding: 1.5rem 2.5rem;
  margin: 0.5rem 0.25rem;
  flex-direction: column;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${ACCENT_800};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${ACCENT_800};
  }
  &::-webkit-scrollbar-track {
    background: ${DAVYS_GREY_400};
    border-radius: 10px;
  }

  @media screen and (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;

export const Footer = styled(FlexBox)`
  padding: 1rem 1.5rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${DAVYS_GREY_400};
  position: relative;
`;

export const IconsContainer = styled(FlexBox)`
  justify-content: center;
  column-gap: 2rem;
  padding: 1rem;
  border: 1px solid ${DAVYS_GREY_400};
  border-radius: 8px;
  width: fit-content;
  margin: 0 auto;
`;

export const Divider = styled.div`
  width: 1px;
  height: 2rem;
  background-color: ${DAVYS_GREY_400};
`;

export const CloseIcon = styled(FlexBox)`
  height: 2rem;
  width: 2rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`;

export const StepDots = styled(FlexBox)`
  gap: 0.375rem;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const Dot = styled.span`
  height: 0.5rem;
  width: ${({ active }) => (active ? "1rem" : "0.5rem")};
  border-radius: 999px;
  background-color: ${({ active }) => (active ? ACCENT_800 : "transparent")};
  border: ${({ active }) => (active ? "none" : `1px solid ${ACCENT_800}`)};
  transition:
    width 0.2s,
    background-color 0.2s;
`;

export const FeatureCard = styled(FlexBox)`
  padding: 1rem;
  background-color: ${DAVYS_GREY_200};
  border-radius: 0.75rem;
  margin: 0.75rem 0 0 0;
  flex-direction: column;
`;

export const Block1 = styled(FlexBox)`
  justify-content: space-between;
  flex-direction: column;
  border: 1px solid ${DAVYS_GREY_400};
  border-radius: 1rem;
  margin: 5rem 0 0.5rem 0;
`;

export const ToggleContainer = styled(FlexBox)`
  border-top: 1px solid ${DAVYS_GREY_400};
  width: 100%;
  justify-content: space-between;
  padding: 1rem;
`;

export const KnowMoreSection = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SessionBulletRow = styled(FlexBox)`
  align-items: flex-start;
  column-gap: ${({ columnGap }) => columnGap || "1rem"};
`;

export const SessionBulletIcon = styled(FlexBox)`
  min-width: 1.5rem;
  justify-content: center;
  margin-top: 0.25rem;
`;
